<form [formGroup]="e.questionForm" class="questionForm row justify-content-center mx-0"
  (keydown)=keyDownActions($event)>

  <div class="input-container mx-0 px-0 col">
    <textarea #questionFormInput class="form-control  w-97 h-100" autofocus="autofocus" id="questionInput"
      formControlName="questionInput" placeholder="Enter your question" maxlength="255"></textarea>
  </div>
</form>